
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: "ri-plane-line",
      title: t('services.airport.title'),
      description: t('services.airport.desc')
    },
    {
      icon: "ri-briefcase-line",
      title: t('services.business.title'),
      description: t('services.business.desc')
    },
    {
      icon: "ri-heart-line",
      title: t('services.events.title'),
      description: t('services.events.desc')
    },
    {
      icon: "ri-user-star-line",
      title: t('services.chauffeur.title'),
      description: t('services.chauffeur.desc')
    }
  ];

  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto px-4">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div key={index} className="text-center group hover:transform hover:-translate-y-2 transition-all duration-300 p-4">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:bg-yellow-300 transition-colors">
                <i className={`${service.icon} text-2xl sm:text-3xl text-black`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
